import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
// Icons
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const formatDateSafe = (dateInput: Date | string | null | undefined): string | null => {
    if (!dateInput) return null;

    let dateObj: Date;
    if (dateInput instanceof Date) {
        dateObj = dateInput;
    } else {
        try {
            dateObj = parseISO(dateInput);
        } catch {
            return null;
        }
    }

    if (isNaN(dateObj.getTime())) return null;
    return format(dateObj, 'dd/MM/yyyy', { locale: ptBR });
};

export const RecorteDataNascimentoFilterPreview = () => {
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao);
    const { removeEditRecorteFormFiltros } = useRecortesExtracaoService();

    const filtros = editRecorteExtracaoForm.fields.Filtros?.dataNascimento;
    const minFormatted = filtros?.min ? formatDateSafe(filtros.min) : null;
    const maxFormatted = filtros?.max ? formatDateSafe(filtros.max) : null;

    return (
        <Grid item container xs={6} spacing={2} mb={2}>
            <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                <Grid item xs={12} container justifyContent="space-between" alignItems="center" my={1}>
                    <Grid item>
                        <Typography
                            variant="body1"
                            color="primary"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mr={2}
                        >
                            Data de Nascimento
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            onClick={() => removeEditRecorteFormFiltros({ filtro: 'dataNascimento' })}
                        >
                            Remover filtro
                        </Button>
                    </Grid>
                </Grid>

                {filtros && (
                    <Grid item xs={12}>
                        <Stack direction="row" flexWrap="wrap">
                            {minFormatted && (
                                <Chip
                                    key="min"
                                    icon={<CalendarMonthIcon />}
                                    label={`de: ${minFormatted}`}
                                    sx={{ m: 0.5 }}
                                />
                            )}
                            {maxFormatted && (
                                <Chip
                                    key="max"
                                    icon={<CalendarMonthIcon />}
                                    label={`até: ${maxFormatted}`}
                                    sx={{ m: 0.5 }}
                                />
                            )}
                        </Stack>
                    </Grid>
                )}
            </Paper>
        </Grid>
    );
};